import { TrainStation } from './train_stations'
import { Waypoint } from './waypoint';

export const app_state = {
    waypoints: [],
    current_path: {
        distance: 0,
        duration: 0,
        raw_data: null,
        features_collection: [],
        ascent: 0,
        descent: 0,
    },
    camp_sites: [],
    train_stations: [],
    live_localization: false,
    last_location: null,
    rainviewer_layers:[],
    rainviewerTimestamps: [],
    current_rainviewer_timestamp: 13,
    readableRainviewerTimestamps: [],
}

// Callbacks list:
export var OnAddWaypoint = [];
export var OnRemoveWaypoint = [];
export var OnChangedWaypoint = [];
export var OnPathChanged = [];
export var OnLiveLocalizationChanged = [];
export var OnCampsiteAdded = [];
export var OnCampsiteClear = [];
export var OnTrainStationAdded = [];
export var OnTrainStationClear = [];


export var app_mgr = {

    bounding_box_getter: () => { return null; },

    getWaypointIdx(wp_id) {
        const idx = app_state.waypoints.findIndex((el) => {
            return el.id == wp_id;
        });
        return idx;
    },

    getWaypoint(wp_id) {
        const idx = this.getWaypointIdx(wp_id);
        if (idx != -1) {
            return app_state.waypoints[idx];
        }
        return null;
    },

    addWaypoint(lon, lat, alt) {
        const wp = new Waypoint(lon, lat, alt);
        app_state.waypoints.push(wp);
        for (let cb of OnAddWaypoint) {
            cb(wp)
        }
        return wp.id;
    },

    removeWaypoint(wp_id) {
        const idx = this.getWaypointIdx(wp_id);
        if(idx != -1) {
            app_state.waypoints.splice(idx, 1);
            for(let cb of OnRemoveWaypoint) {
                cb(wp_id);
            }
        }
    },

    moveWaypointUp(wp_id) {
        const idx = this.getWaypointIdx(wp_id);
        if(idx != -1) {
            const tmp = app_state.waypoints[idx];
            app_state.waypoints[idx] = app_state.waypoints[idx - 1];
            app_state.waypoints[idx - 1] = tmp;
        }
    },

    moveWaypointDown(wp_id) {
        const idx = this.getWaypointIdx(wp_id);
        if(idx != -1) {
            const tmp = app_state.waypoints[idx];
            app_state.waypoints[idx] = app_state.waypoints[idx + 1];
            app_state.waypoints[idx + 1] = tmp;
        }
    },

    setWaypointValues(wp_id, lon=0, lat=0, name="") {
        const idx = this.getWaypointIdx(wp_id);
        if (idx == -1) {
            return;
        }
        let waypoint = app_state.waypoints[idx];
        // change values:
        waypoint.update(lon, lat, name);
        for (let cb of OnChangedWaypoint) {
            cb(waypoint);
        }
    },

    setCurrentPath(distance, duration, raw_data=null, features_collection=null, ascent=0, descent=0) {
        app_state.current_path.distance = distance;
        app_state.current_path.duration = duration;
        app_state.current_path.raw_data = raw_data;
        app_state.current_path.features_collection = features_collection;
        app_state.current_path.ascent = ascent;
        app_state.current_path.descent = descent;

        for (let cb of OnPathChanged) {
            cb();
        }
    },

    clearCurrentPath() {
        app_state.current_path.distance = 0;
        app_state.current_path.duration = 0;
        app_state.current_path.raw_data = null;
        app_state.current_path.features_collection = [];
        for (let cb of OnPathChanged) {
            cb();
        }
    },

    setLiveLocalizationState(state) {
        app_state.live_localization = state;
        for (let cb of OnLiveLocalizationChanged) {
            cb();
        }
        localStorage.setItem("liveLocalization", app_state.live_localization);
    },

    addCampsite(localization, type, info) {
        app_state.camp_sites.push({
            localization: localization,
            type: type,
            info: info
        })
        for (let cb of OnCampsiteAdded) {
            cb(localization, info); // BEURK
        }
    },

    clearCampsites() {
        app_state.camp_sites = [];
        for(let cb of OnCampsiteClear) {
            cb();
        }
        // this.saveAppState();
    },

    addTrainStation(localization, type, info) {
        // do not add a train station we already registered:
        if(app_state.train_stations.find(ts => ts.getUIC() === info.uic_ref) != undefined) {
            return;
        }
        app_state.train_stations.push(new TrainStation(localization, type, info));
        for (let cb of OnTrainStationAdded) {
            cb(app_state.train_stations[app_state.train_stations.length - 1]); // BEURK
        }
    },

    clearTrainStations() {
        app_state.train_stations = [];
        for(let cb of OnTrainStationClear) {
            cb();
        }
    },

    getCurrentBoundingBox() {
        return this.bounding_box_getter(); 
    },

    setLocation(loc) {
        app_state.last_location = loc;
    }
}